module.exports = __webpack_public_path__ + "img/proapp-main.eaa67493.webp";